






import Vue from 'vue'
import VoiceDetailContainer from '@/containers/Voice/Detail'
import FetchVoiceUseCase from '@/usecases/voice/FetchVoiceUseCase'
import { VoiceNotFoundError } from '@/common/errors/voice'
import { ErrorType } from '@/common/errors'
import VoiceEntity from '@/entities/Voice'

export default Vue.extend({
  components: {
    VoiceDetailContainer
  },
  middleware: ['loginCheck'],
  async fetch({ $microcmsGateway, $voiceRepository, params, error }) {
    const id = params['id']
    const fetchVoiceUseCase = new FetchVoiceUseCase({
      microcmsGateway: $microcmsGateway,
      voiceRepository: $voiceRepository
    })

    try {
      await fetchVoiceUseCase.execute(id)
    } catch (e) {
      if (e instanceof VoiceNotFoundError) {
        error({ statusCode: ErrorType.NOT_FOUND, message: e.message })
        return
      }

      // TODO: handle error
      throw e
    }
  },
  head() {
    const voiceEntity: VoiceEntity | null = this.$voiceRepository.getVoiceById(this.voiceId)
    let pageTitle: string
    let pageDescription: string
    let ogImage: string
    if (voiceEntity) {
      // 取得したタイトルに「」が含まれるので、文字列の先頭と末尾をsliceする
      pageTitle = voiceEntity.props.title.slice(1).slice(0, -1)
      pageDescription = voiceEntity.props.content
      ogImage = 'https:' + voiceEntity.props.articleImage
    } else {
      pageTitle = 'お客さまの声・口コミ'
      pageDescription = 'スクールフォト販売サイト スナップスナップを利用したお客さまから、ご意見・ご感想をいただきました。'
      ogImage = 'https://snapsnap.jp/static/ogp/snapsnap.jpg'
    }
    return {
      title: pageTitle,
      meta: [
        { hid: 'description', name: 'description', content: pageDescription },
        { hid: 'og:title', property: 'og:title', content: pageTitle },
        { hid: 'og:description', property: 'og:description', content: pageDescription },
        { hid: 'og:image', property: 'og:image', content: ogImage }
      ]
    }
  },
  computed: {
    voiceId(): string {
      return this.$route.params['id']
    }
  }
})
